import { CheckIcon } from "./Icons";
import ui from "./ui.module.css";

// Gentle feedback in the Teacher App's notice style, worded only from what the
// gateway's policy permits (Learner Work Policy v1 §2). It never grades and
// never shows an answer. The space is kept even when empty so cards don't jump.
//
//   right     Well done!                 correct
//   recorded  Your answer is saved.      incorrect, kept, moving on
//   saved     Saved                      open work, or feedback withheld
//   wrong     Try again                  incorrect; this step needs it right
//   again     Check your work…           not finished; feedback withheld
const MESSAGES = {
  recorded: "Not quite. Your answer is saved.",
  saved: "Saved",
  wrong: "Try again",
  again: "Check your work and try again.",
};

const Feedback = ({ kind }) => (
  <div className={ui.feedback} role="status">
    {kind === "right" && (
      <p className={ui.notice}>
        <CheckIcon className={ui.done} size={24} />
        Well done!
      </p>
    )}
    {kind === "saved" && (
      <p className={ui.notice}>
        <CheckIcon className={ui.done} size={24} />
        {MESSAGES.saved}
      </p>
    )}
    {(kind === "wrong" || kind === "again" || kind === "recorded") && (
      <p className={`${ui.notice} ${ui.warning}`}>{MESSAGES[kind]}</p>
    )}
  </div>
);

export default Feedback;
